import Cookies from 'js-cookie';

const baseURL = process.env.REACT_APP_API_URL;

export default function apiClient(endpoint: string, options: RequestInit = {}) {
  const url = `${baseURL}${endpoint}`;
  const token = Cookies.get('token');

  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json'
    }
  });
}
